import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import appointmentAPI from '../../sources/api/appointmentAPI';

// constants
import { APPOINTMENT_UPDATE } from '../../constants/appointmentTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { appointmentSchema } from '../../schemas/Normalizr';
import { DATA_EDIT_ERROR, DATA_EDIT_SUCCESS } from '../../constants/messages';
import { toastr } from 'react-redux-toastr';

export function* appointmentUpdate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(APPOINTMENT_UPDATE, call(appointmentAPI.update, params), appointmentSchema);
    yield toastr.success('Success', DATA_EDIT_SUCCESS);
  } catch (e) {
    yield toastr.error(DATA_EDIT_ERROR);
    yield put(error(APPOINTMENT_UPDATE, e));
  } finally {
    yield put(doneIndicator(APPOINTMENT_UPDATE));
  }
}

export function* watchappointmentUpdate() {
  yield takeEvery(APPOINTMENT_UPDATE, appointmentUpdate);
}

export default function* root() {
  yield all([
    fork(watchappointmentUpdate)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/appointment/appointmentUpdate.js